import { IGetState, TBoardId, TCardId } from './../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import {
    SegmentCardEvent,
    SegmentCardOptions,
    SegmentCardSection,
    segmentTrackAction
} from '../../../../../../../../middlewares/segment';
import { getSectionType } from '../../../../selectors/getSectionType';
import { ESettingsSectionType } from '../../../../../../base/components/SettingsSection/types';
import { disallowedSectionClickedEvent } from '../../../../effects/segmentEvents';
import { getBoardIsCardDefaultProperty } from '../../../../../../../../store/model/board/selectors/getBoardIsCardDefaultProperty';
import { getCardSubcardsCount } from '../../../../../../../../store/model/selectors/getCardSubcardsCount';
import { EAsidePanelProperty } from '../../../../../asidePanel/components/AsidePanel/types';
import { showSnoozeBlocker } from '../../../../../../base/effects/showSnoozeBlocker';
import { SegmentCardSourceValue } from 'app/middlewares/segment/trackEntities/cardEvents';

export const onClick = (
    boardId: TBoardId,
    cardId: TCardId,
    ownOnClick?: () => void
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const isFirst = !getCardSubcardsCount(getState(), cardId) &&
            !getBoardIsCardDefaultProperty(getState(), boardId, EAsidePanelProperty.CARD_SUBCARDS);
        dispatch(segmentTrackAction(SegmentCardEvent.BUTTONS_PANEL_BUTTON_CLICKED, {
            name: SegmentCardOptions.TARGET,
            value: SegmentCardSection.SUBCARDS
        }, [{
            name: SegmentCardOptions.FIRST,
            value: String(isFirst)
        }]));
        if (ownOnClick) ownOnClick();

        const sectionType = getSectionType(getState(), boardId, cardId, null, 'allowSubCard');
        const isDisallow = sectionType === ESettingsSectionType.DISALLOW;

        if (isDisallow) {
            dispatch(showSnoozeBlocker({
                allow: 'allowSubCard'
            }));
            dispatch(disallowedSectionClickedEvent(SegmentCardSection.SUBCARDS, SegmentCardSourceValue.BUTTONS_PANEL));
        }
    };
    return action;
};
